import { Inject, Injectable, Injector, OnDestroy } from '@angular/core';
import { ComponentType, Overlay } from '@angular/cdk/overlay';

import { BehaviorSubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { RxGalleryPreviewService } from './gallery-preview.service';
import { GalleryPreviewComponentInjector } from '../injectors/gallery-preview-component.injector';
import { GalleryPreviewData } from './preview-data';

@Injectable()
export class RxGalleryService implements OnDestroy {
  public galleryPreviewService: RxGalleryPreviewService;
  public config: any;

  private _data$ = new BehaviorSubject<GalleryPreviewData[]>([]);
  private _print$ = new Subject<GalleryPreviewData>();
  private _download$ = new Subject<GalleryPreviewData>();
  private _destroy$ = new Subject<void>();

  constructor(
    private _overlay: Overlay,
    private _injector: Injector,
    @Inject(GalleryPreviewComponentInjector)
    private _galleryPreviewComponent: ComponentType<object>,
  ) {
    this.galleryPreviewService = new RxGalleryPreviewService(
      _overlay,
      _galleryPreviewComponent,
      _injector,
    );
  }

  public get data$() {
    return this._data$;
  }

  public get print$() {
    return this._print$;
  }

  public get download$() {
    return this._download$;
  }

  public openPreview(item: GalleryPreviewData) {
    this.galleryPreviewService
      .open(item)
      .onClose.pipe(take(1), takeUntil(this._destroy$))
      .subscribe(() => {});
  }

  public getThumbnailImage(data: any) {
    const image: any = { isDouble: false };

    if (this.config.double !== null) {
      const firstImage = data[this.config.double.firstThumbnailField] || null;
      const secondImage = data[this.config.double.secondThumbnailField] || null;

      if (firstImage && secondImage) {
        image.isDouble = true;
        image.firstImage = firstImage;
        image.secondImage = secondImage;
      } else {
        image.image =
          (data.isGif
            ? data[this.config.thumbnailField]
            : data[this.config.double.firstThumbnailField]) || null;
      }
    } else {
      image.image = data[this.config.thumbnailField] || null;
    }

    return image;
  }

  public getPreviewImage(data: any) {
    const image: any = { isDouble: false };

    if (this.config.double !== null) {
      const firstImage = data[this.config.double.firstImageField] || null;
      const secondImage = data[this.config.double.secondImageField] || null;

      if (firstImage && secondImage) {
        image.isDouble = true;
        image.firstImage = firstImage;
        image.secondImage = secondImage;
        image.firstLabel = this.config.double.firstImageLabel;
        image.secondLabel = this.config.double.secondImageLabel;
      } else {
        image.image =
          (data.isGif ? data[this.config.imageField] : data[this.config.double.firstImageField]) ||
          null;
      }
    } else {
      image.image = data[this.config.imageField] || null;
    }

    return image;
  }

  public ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
